import { Component, inject } from "@angular/core";
import { ClientConfigService } from "@app/core/config/client-config.service";
import {
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose
} from "@angular/material/dialog";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatAnchor, MatButton } from "@angular/material/button";
import { TranslatePipe } from "@ngx-translate/core";
import { SafePipe } from "../../shared/pipes/safe.pipe";

export class ApiViewerData {
  public docsName: string;
}

@Component({
  selector: "app-api-viewer",
  templateUrl: "./api-viewer.component.html",
  styleUrls: ["./api-viewer.component.css"],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatDialogActions,
    MatAnchor,
    MatButton,
    MatDialogClose,
    TranslatePipe,
    SafePipe
  ]
})
export class ApiViewerComponent {
  private clientConfigService = inject(ClientConfigService);
  data = inject<ApiViewerData>(MAT_DIALOG_DATA);

  public static documentLocations = {
    all: "docs/index.html",
    resources: "docs/resources.docs.html",
    jobs: "docs/auth.docs.html",
    jobSchedules: "docs/jobSchedules.docs.html",
    messaging: "docs/messaging.docs.html",
    overview: "docs/overview.docs.html",
    priority: "docs/priority.docs.html",
    scheduler: "docs/scheduler.docs.html",
    skill: "docs/skill.docs.html",
    skillProfile: "docs/skillProfile.docs.html",
    sor: "docs/sor.docs.html",
    tickets: "docs/tickets.docs.html",
    visits: "docs/visits.docs.html",
    zones: "docs/zones.docs.html"
  };
  public frameUrl = "";

  constructor() {
    const clientConfigService = this.clientConfigService;
    const data = this.data;

    console.log(data.docsName);
    console.log(ApiViewerComponent.documentLocations);

    this.frameUrl =
      clientConfigService.config.serviceUrl +
      "/" +
      ApiViewerComponent.documentLocations[data.docsName];
  }

  public static getUrl(docsName: string) {
    console.log(docsName);
    console.log(ApiViewerComponent.documentLocations);
    return (
      window.localStorage["soapUrl"] +
      "/" +
      ApiViewerComponent.documentLocations[docsName]
    );
  }
}
